import { feesList, feesSpecialList } from '@/api/api-values'

export const KIND_MARKET = 'market'
export const KIND_LIFE_INSURANCE = 'lifeinsurance'
export const KIND_CAPITALISATION = 'capitalisation'
export const KIND_PEA = 'pea'
export const KIND_SAVINGS = 'savings'
export const KIND_PEE = 'pee'
export const KIND_PERCO = 'perco'
export const KIND_ARTICLE83 = 'article83'
export const KIND_RSP = 'rsp'
export const KIND_CHECKING = 'checking'
export const KIND_CARD = 'card'
export const KIND_DEPOSIT = 'deposit'
export const SAVING_KIND_LIVRET_A = 'livret_a'
export const SAVING_KIND_LIVRET_JEUNE = 'livret_jeune'
export const SAVING_KIND_LDD = 'ldd'
export const SAVING_KIND_PEL = 'pel'
export const SAVING_KIND_CEL = 'cel'
export const SAVING_KIND_LEP = 'lep'
export const KIND_LOAN = 'loan'
export const KIND_MADELIN = 'madelin'
export const KIND_PERP = 'perp'
export const KIND_PER = 'per'

export const ONBOARDING_ORIGIN_ESR = 'esr'
export const ONBOARDING_ORIGIN_ESR_MERGE = 'esr_wesave_merged'

export const filterDevicesList = [
  'ag2r-la-mondiale',
  'amundi',
  'allianz-retraite-collective',
  'cnp-retraite-entreprises',
  'aviva',
  'axa-epargne-retraite',
  'axa-epargne-salariale',
  'bnp-paribas-epargne---retraite-entreprises',
  'caceis',
  'cic-epargne-salariale',
  'societe-generale',
  'credit-mutuel-epargne-salariale',
  'epsens-epargne-salariale',
  'epsor',
  'federal-finance-epargne-salariale',
  'groupama-epargne-salariale',
  'hsbc-epargne-salariale',
  'banque-postale-epargne-salariale',
  'macsf',
  'malakoff-humanis-epargne-salariale',
  'natixis-interepargne',
  'uptevia',
  'sharinbox',
  'societe-generale-epargne-salariale',
  'sogeretraite',
  'credit-agricole---epargne-longue-des-salaries',
  'union-financiere-de-france',
  'swisslife',
  'maaf-vie',
  'groupama',
  'gan-prevoyance',
  'gan-assurances',
  'gan-patrimoine',
  'credit-mutuel-du-sud-ouest',
  'connecteur-de-test'
]

export const firstConnectorDisplayed = [
  'credit-agricole',
  'societe-generale',
  'bnp-paribas',
  'cic',
  'caisse-depargne',
  'wesave'
]

export const kindRepartitionWhitelist = [
  KIND_MARKET,
  KIND_LIFE_INSURANCE,
  KIND_CAPITALISATION,
  KIND_PEA,
  KIND_SAVINGS,
  KIND_PEE,
  KIND_PERCO,
  KIND_ARTICLE83,
  KIND_RSP,
  KIND_CHECKING,
  KIND_CARD,
  KIND_DEPOSIT
]

export const bankContractKinds = [KIND_CHECKING, KIND_CARD, KIND_DEPOSIT]

export const supportedContractKinds = [
  KIND_LIFE_INSURANCE,
  KIND_CAPITALISATION,
  KIND_PEA,
  KIND_PEE,
  KIND_MARKET,
  KIND_SAVINGS,
  KIND_CHECKING,
  KIND_CARD,
  KIND_DEPOSIT,
  KIND_LOAN,
  KIND_PERCO,
  KIND_MADELIN,
  KIND_PERP,
  KIND_PER,
  KIND_ARTICLE83,
  KIND_RSP
]

export const riskedContractKinds = [
  KIND_LIFE_INSURANCE,
  KIND_CAPITALISATION,
  KIND_PEA,
  KIND_MARKET,
  KIND_PERCO,
  KIND_PEE,
  KIND_ARTICLE83
]

export const supportedSavingsKinds = [
  SAVING_KIND_LIVRET_A,
  SAVING_KIND_LIVRET_JEUNE,
  SAVING_KIND_LDD,
  SAVING_KIND_PEL,
  SAVING_KIND_CEL,
  SAVING_KIND_LEP
]

// the order of kinks will correspond to the order of display in the sidebar
export const supportedESRKinds = [
  KIND_RSP,
  KIND_PEE,
  KIND_PERCO,
  KIND_ARTICLE83,
  KIND_PERP,
  KIND_PER,
  KIND_MADELIN
]

export const subTypeLegalOfESRKinds = {
  [KIND_PERCO]: [KIND_PERCO, 'percoi', 'percol'],
  [KIND_PEE]: [KIND_PEE, 'peg', 'pei', 'pelt', 'hes']
}

export const editableContractInformation = [
  'externalCreatedAt',
  'typeInvestment',
  'targetAmount',
  'timeInvestment',
  'monthlyDeposit',
  'monthlyBuyout',
  'managementType'
]

export const analyzableContracts = [KIND_LIFE_INSURANCE, KIND_CAPITALISATION]

export function isLifeInsurance({ kind }) {
  return kind === KIND_LIFE_INSURANCE || kind === KIND_CAPITALISATION
}

export function isMarket({ kind }) {
  return kind === KIND_MARKET
}

export function isPEA({ kind }) {
  return kind === KIND_PEA
}

export function isLoan({ kind }) {
  return kind === KIND_LOAN
}

export function isESRContract({ kind }) {
  return supportedESRKinds.includes(kind)
}

export function isRisked({ kind }) {
  return riskedContractKinds.includes(kind)
}

export function isChecking({ kind }) {
  return kind === KIND_CHECKING
}

export function isSupportedKind({ kind }) {
  return supportedContractKinds.includes(kind)
}

export function isSupportedSaving({ kindDetail }) {
  return supportedSavingsKinds.includes(kindDetail)
}

export function isSupported(contract) {
  return (
    isSupportedKind(contract) &&
    (contract.kind !== KIND_SAVINGS || isSupportedSaving(contract))
  )
}

export function getHistoryTime({ history }) {
  if (!history.length) return {}

  return {
    from: history ? new Date(history[0][0]) : Date.now(),
    to: history ? new Date(history[history.length - 1][0]) : Date.now()
  }
}

export function isBankAccount({ kind }) {
  return bankContractKinds.includes(kind)
}

export function isContractTypeAnalyzable({ kind }) {
  return analyzableContracts.includes(kind)
}

export function contractFeeNames(contract) {
  return isLifeInsurance(contract) ? feesList : feesSpecialList
}

export function isAmundiEsrAccount(account) {
  return account.bank.slug.includes('amundi-esr')
}

export function contractCompanyName(contract) {
  return findInCustomFieldsContract(contract, 'nomEntreprise')
}

export function contractSubLegalType(contract) {
  return findInCustomFieldsContract(contract, 'sousTypeLegal').toLowerCase()
}

export function findInCustomFieldsContract(contract, findKey) {
  const { customFields } = contract
  if (!customFields || customFields.length === 0) return ''

  const find = customFields.find(({ key }) => {
    return key === findKey
  })

  return find && find.value ? find.value : ''
}

export function isCustomerESR(customer) {
  const { profile } = customer
  return profile && profile.onboardingOrigin === ONBOARDING_ORIGIN_ESR
}
